import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type ReactNode } from 'react';
import { Icon } from '../icons/icons';
import styles from './ChecklistBlock.module.scss';

/**
 * The check's colour (O103): `accent` (the default) is the accent text,
 * `current` the item's own text colour (`currentColor`), for a checklist on a
 * dark band whose items set their colour.
 */
export type ChecklistBlockIconTone = 'accent' | 'current';

/**
 * The rhythm between items (Phase 5 PR 5.3 fix round, S2): `default` puts the
 * 20px item gap (`space-5`) after each item; `none` sets them line after line,
 * the paid landers' hero lists, whose items carry the lead line-height.
 */
export type ChecklistBlockSpacing = 'default' | 'none';

/**
 * The layout (2026-10-13): `1` (the default) is one list; `2` lays the items
 * out column-wise as two lists side by side from the md breakpoint, the first
 * list taking the first half and the extra item of an odd count. Below md the
 * two stack with no gap between them, so the list reads as one rhythm — a
 * page-level Grid around two ChecklistBlocks added its row gap to the item
 * gap on phones (the ASHCA lander's and the healthcare degree page's "What
 * you'll learn").
 */
export type ChecklistBlockColumns = 1 | 2;
export interface ChecklistBlockProps {
  /** Defaults to `accent`. */
  iconTone?: ChecklistBlockIconTone;
  /** Defaults to `default`. */
  spacing?: ChecklistBlockSpacing;
  /** Defaults to `1`. */
  columns?: ChecklistBlockColumns;
  items: ReactNode[];
}
function ChecklistBlock(t0) {
  const $ = _c(12);
  const {
    iconTone: t1,
    spacing: t2,
    columns: t3,
    items
  } = t0;
  const iconTone = t1 === undefined ? "accent" : t1;
  const spacing = t2 === undefined ? "default" : t2;
  const columns = t3 === undefined ? 1 : t3;
  const t4 = iconTone === "current" && styles["helios-checklist--icon-current"];
  const t5 = spacing === "none" && styles["helios-checklist--spacing-none"];
  let t6;
  if ($[0] !== t4 || $[1] !== t5) {
    t6 = classNames(styles["helios-checklist"], t4, t5);
    $[0] = t4;
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const listClassName = t6;
  let t7;
  if ($[3] !== listClassName) {
    t7 = (listItems, t8) => {
      const keyOffset = t8 === undefined ? 0 : t8;
      return <ul className={listClassName}>{listItems.map((item, i) => <li key={keyOffset + i} className={styles["helios-checklist__item"]}><Icon name="check" className={styles["helios-checklist__icon"]} />{item}</li>)}</ul>;
    };
    $[3] = listClassName;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const renderList = t7;
  if (columns === 2) {
    const split = Math.ceil(items.length / 2);
    let t8;
    if ($[5] !== items || $[6] !== renderList || $[7] !== split) {
      const rest = items.slice(split);
      t8 = <div className={styles["helios-checklist-columns"]}>{renderList(items.slice(0, split))}{rest.length > 0 && renderList(rest, split)}</div>;
      $[5] = items;
      $[6] = renderList;
      $[7] = split;
      $[8] = t8;
    } else {
      t8 = $[8];
    }
    return t8;
  }
  let t8;
  if ($[9] !== items || $[10] !== renderList) {
    t8 = renderList(items);
    $[9] = items;
    $[10] = renderList;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
export default ChecklistBlock;